/* eslint-disable */
/*
* shared.js
*
* Description: Holds 'Stores' Logic for Module:'Shared'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - People"
* Copyright 2018,2019,2020 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import router from '@/router'; // after login

import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> Drawer -----------------------------------------
    barColor: 'rgba(45, 62, 82, 1), rgba(45, 62, 82, 1)',
    barImage: '', /* is OFF right now, LEA */
    drawer: null,

    // >>> Login ------------------------------------------
    sharedLoginResults: {}, // Results::Login
    idGroup: null,
    idResource: null,
    idUser: null,
    realName: null,
    userName: null,
    shared_usersGrantsList: [],

    // >>> Airports ---------------------------------------
    sharedAirportResults: {}, // Results::Airports
    // >>> Aircrafts --------------------------------------
    people_aircraftConfigs: [],
    shared_airportTaxes: [],
    // >>> Countries --------------------------------------
    people_Countries: [],
    // >>> Bases ------------------------------------------
    people_Bases: [],

    // >>> All Employees ----------------------------------
    shared_AllEmployeesResults: [], // Results::'All Employees'
    shared_SelectedMultiResources: [], // Multi Reources Select

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Shared' - 'Login'
    ***************************************************************************/
    /***************************************************************************
    * isAuthenticated()
    *
    * Desc: Dear ... are we authenticated?
    * Note:
    *
    */
    isAuthenticated: state => {

        return state.idUser !== null;

    }, // eof isAuthenticated()


    /***************************************************************************
    * getIdUser()
    *
    * Desc:
    * Note:
    *
    */
    getIdUser: state => {

        return state.idUser;

    }, // eof getIdUser()


    /***************************************************************************
    * get_Shared_UsersGrantsList()
    *
    * Desc: Return Grabnts List (Note: from /login Response).
    * Note:
    *
    */
    get_Shared_UsersGrantsList: state => {

        return state.shared_usersGrantsList;

    }, // eof get_Shared_UsersGrantsList()




    /***************************************************************************
    * Getters: 'Shared' - AircraftConfigs
    ***************************************************************************/
    /***************************************************************************
    * get_AircraftConfigs()
    *
    * Desc:
    * Note:
    *
    */
    get_AircraftConfigs: state => {

        return state.people_aircraftConfigs;

    }, // eof get_AircraftConfigs()




    /***************************************************************************
    * Getters: 'Shared' - AirportTaxes
    ***************************************************************************/
    /***************************************************************************
    * get_AirportTaxes()
    *
    * Desc:
    * Note:
    *
    */
    get_AirportTaxes: state => {

        return state.shared_airportTaxes;

    }, // eof get_AirportTaxes()




    /***************************************************************************
    * Getters: 'Shared' - Countries
    ***************************************************************************/
    /***************************************************************************
    * get_Countries()
    *
    * Desc:
    * Note:
    *
    */
    get_Countries: state => {

        return state.people_Countries;

    }, // eof get_Countries()




    /***************************************************************************
    * Getters: 'Shared' - Bases
    ***************************************************************************/
    /***************************************************************************
    * get_Bases()
    *
    * Desc:
    * Note:
    *
    */
    get_Bases: state => {

        return state.people_Bases;

    }, // eof get_Bases()




    /***************************************************************************
    * Getters: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * get_AllEmployees()
    *
    * Desc:
    * Note: Still empty!
    *
    */
    get_AllEmployees: state => {

        return state.shared_AllEmployeesResults;

    }, // eof get_AllEmployees()


    /***************************************************************************
    * get_selectedMultiResources()
    *
    * Desc: Return selected Multi Resources.
    * Note: Still empty!
    *
    */
    get_selectedMultiResources: state => {

        return state.shared_SelectedMultiResources;

    }, // eof get_selectedMultiResources()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Shared' - 'Drawer'
    ***************************************************************************/
    /***************************************************************************
    *
    * Desc:
    * Note:
    *
    */
    SET_BAR_IMAGE: (state, payload) => {

        state.barImage = payload;

    }, // eof SET_BAR_IMAGE()

    SET_DRAWER: (state, payload) => {

        state.drawer = payload;

    }, // eof SET_DRAWER()

    SET_SCRIM: (state, payload) => {

        state.barColor = payload;

    }, // eof SET_SCRIM()




    /***************************************************************************
    * Mutations: 'Shared' - 'Login'
    ***************************************************************************/
    /***************************************************************************
    * mut_userLogin()
    *
    * Desc: User Login.
    * Note: NEW! We now have 'grants' in Logins Response.
    * Note: Redirect to '/' Dashboard(!) (bec: First need to check 'grants').
    *
    */
    mut_userLogin: (state, payload) => {

        state.sharedLoginResults = payload;
        state.idGroup = payload.idGroup;
        state.idResource = payload.idResource;
        state.idUser = payload.idUser;
        state.realName = payload.realName;
        state.userName = payload.userName;
        state.shared_usersGrantsList = payload.grants;

        router.push('/');

    }, // eof mut_userLogin()




    /***************************************************************************
    * Mutations: 'Shared' - 'Countries'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_Countries()
    *
    * Desc: Save countries to state.
    * Note: Countries are not sorted, sort them by name.
    *
    */
    mut_call_Countries: (state, payload) => {

        let sortedCountries = [...payload];


        sortedCountries.sort((a, b) => a.name < b.name ? -1 : 1);

        state.people_Countries = sortedCountries;

    }, // eof mut_call_Countries()




    /***************************************************************************
    * Mutations: 'Aircrafts'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_AircraftConfigs()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_AircraftConfigs: (state, payload) => {

        state.people_aircraftConfigs = payload;

    }, // eof mut_call_AircraftConfigs()




    /***************************************************************************
    * Mutations: 'AirportTaxes'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_AirportTaxes()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_AirportTaxes: (state, payload) => {

        let sortedAirports = [...payload];


        sortedAirports.sort((a, b) => a.aptCode < b.aptCode ? -1 : 1);

        state.shared_airportTaxes = sortedAirports;
        // state.shared_airportTaxes = payload;

    }, // eof mut_call_AirportTaxes()



    /***************************************************************************
    * Mutations: 'Shared' - 'Bases'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_Bases()
    *
    * Desc: Save countries to state.
    * Note:
    *
    */
    mut_call_Bases: (state, payload) => {

        state.people_Bases = payload;

    }, // eof mut_call_Bases()




    /***************************************************************************
    * Mutations: 'Shared' - 'Save Duty Plan Changes'
    ***************************************************************************/
    /***************************************************************************
    * mut_update_DutyPlanChanges()
    *
    * Desc: Update List 'All Employees' with new 'created' TimeStamp.
    * Note:
    *
    */
    mut_update_DutyPlanChanges: (state, payload) => {

        let sr = null;


        payload.forEach((item, i) => {
            sr = state.shared_AllEmployeesResults.find(resource => resource.id === item.idResource);
            sr.lastDutyPlanRelease = item.created;
        });

    }, // eof mut_update_DutyPlanChanges()




    /***************************************************************************
    * Mutations: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * mut_load_AllEmployees()
    *
    * Desc: After Load 'All Employees'.
    * Note:
    *
    */
    mut_load_AllEmployees: (state, payload) => {

        payload.sort((a, b) => (a.genLastname > b.genLastname) ? 1 : ((b.genLastname > a.genLastname) ? -1 : 0));
        state.shared_AllEmployeesResults = payload;

    }, // eof mut_load_AllEmployees()




    /***************************************************************************
    * Mutations: 'Shared' Selected Resources'
    ***************************************************************************/
    /***************************************************************************
    * mut_set_shared_SelectedMultiResources()
    *
    * Desc: Set
    * Note:
    *
    */
    mut_set_shared_SelectedMultiResources: (context, payload) => {

        state.shared_SelectedMultiResources = payload;

    }, // eof mut_set_shared_SelectedMultiResources()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Shared' - 'Login'
    ***************************************************************************/
    /*************************************************************************** Step 1
    * actn_userLogin()
    *
    * Desc: (Call) - User Login.
    * Note: Set Headers Authorization here!
    * Note: Load Countries & More from here.
    * Note: NEW! We now have 'grants' in Logins Response.
    *
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_userLogin: (context, payload) => {

        let hdrs = '',
            url = 'acm/acl/login';


        // >>> Set 'Authorization' Header -------
        axios.defaults.headers.Authorization = Vue.prototype.$make_basic_auth(payload);

        Vue.prototype.$vp_m();
        axios.get(url, payload.params)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_userLogin', response.data);         // calling mutation

                        context.dispatch("actn_call_getCountries", {});         // load countries
                        context.dispatch("actn_call_getAirportTaxes", {});      // load airportTaxes
                        context.dispatch("actn_call_getHotelGoodies", {});      // load hotel gooddies
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eof actn_userLogin()


    /***************************************************************************
    * actn_userLogout()
    *
    * Desc:
    * Note:
    *
    */
    actn_userLogout: (context, payload) => {

        console.log('TODO: actn_userLogout');

    }, // eof actn_userLogout()


    /***************************************************************************
    * actn_userSignup()
    *
    * Desc:
    * Note:
    *
    */
    actn_userSignup: (context, payload) => {

        console.log('TODO: actn_userSignup');

    }, // eof actn_userSignup()




    /***************************************************************************
    * Actions: 'Shared' - Load Countries
    ***************************************************************************/
    /***************************************************************************
    * Call::'/info/countries'
    *
    * Desc: Call: Get List of Countries.
    * Note:
    *
    */
    actn_call_getCountries: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/info/countries')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_Countries', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCountries()




    /***************************************************************************
    * Actions: 'Shared' - - Load Bases
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/bases'
    *
    * Desc: Call: Get List of Bases.
    * Note:
    *
    */
    actn_call_getBases: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/humanresources/bases')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_Bases', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getBases()




    /***************************************************************************
    * Actions: 'Shared' - Load Aircraft(s)
    ***************************************************************************/
    /***************************************************************************
    * Call::'acm/forms/aircraftconfigs'
    *
    * Desc: Call: Get List of Aircrafts.
    * Note:
    *
    */
    actn_call_getAircraftConfigs: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/acm/forms/aircraftconfigs')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_AircraftConfigs', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getAircraftConfigs()


    /***************************************************************************
    * Actions: 'Shared' - Load Airport Taxes
    ***************************************************************************/
    /***************************************************************************
    * Call::'/acm/airport/taxes'
    *
    * Desc: Call: Get List of Airport Taxes.
    * Note:
    *
    */
    actn_call_getAirportTaxes: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/acm/airport/taxes')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_AirportTaxes', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getAircraftConfigs()



    /***************************************************************************
    * Actions: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * actn_call_load_AllEmployees()
    *
    * Desc: (Call) - Load 'All Employees'
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note:
    *
    */
    actn_call_load_AllEmployees: (context, payload) => {

        let hdrs = '';


        axios.get('/humanresources/resource/active', payload.params)
            .then(function (response) {
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_AllEmployees', response.data); // calling mutation
                        eventBus.$emit('onallemployeesloaded', {});             //
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) {
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eof actn_call_load_AllEmployees()




    /***************************************************************************
    * Actions: 'Shared' - 'All Employees - Save Duty Plan Changes'
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/resource/dutyplan/generate'
    *
    * Desc: (Call) - Update multiple Ressources. Save Duty Plan Changes.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_update_DutyPlanChanges: (context, payload) => {

        let hdrs = '';


        Vue.prototype.$vp_m();
        axios.put('/humanresources/resource/dutyplan/generate', payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_update_DutyPlanChanges', response.data); // calling mutation

                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Save Duty Plan Changes - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                }
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eof actn_update_DutyPlanChanges()




    /***************************************************************************
    * Actions: 'Shared' - All Employees - Selected Resources'
    ***************************************************************************/
    /***************************************************************************
    * actn_set_shared_SelectedMultiResources()
    *
    * Desc: Set
    * Note:
    *
    */
    actn_set_shared_SelectedMultiResources: (context, payload) => {

        context.commit('mut_set_shared_SelectedMultiResources', payload);

    }, // eof actn_set_shared_SelectedMultiResources()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions
};
